/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import ReminderTriggerItem from "@shared/scheduler/reminders/ReminderTriggerItem";
import {Type, TypeClass} from "@qwoach/class-transformer-wrapper"
import BaseIdObject from "@shared/BaseIdObject.js";
import Discriminator from "@/utils/Discriminator";
import {CalendarReminderItem, EmailReminderItem} from "@shared/scheduler/reminders/reminderItem-imports";
import {ReminderType} from "@shared/scheduler/reminders/ReminderType";
import {DisplayDestinationEnum} from "@shared/Journal/DisplayDestinationEnum";
import ReminderJournalEntry from "@shared/Journal/ReminderJournalEntry";
import {ProfileTypeEnum} from "@shared/Profile/ProfileTypeEnum";
import ScheduledEvent from "@shared/scheduler/ScheduledEvent";
import dayjs from "dayjs"


@TypeClass(Discriminator.create([
	{value: () => EmailReminderItem, name: ReminderType.EMAIL},
	{value: () => CalendarReminderItem, name: ReminderType.CALENDAR},
]))
export default class ReminderItem extends BaseIdObject{

	recipientId: string = null
	recipientType: ProfileTypeEnum = null
	type: ReminderType = null
	triggerAbsoluteTs: number = null //absolute time for this reminder to start
	@Type(() => ReminderTriggerItem)
	trigger = new ReminderTriggerItem(-24 * 60 * 60 * 1000)
	scheduledReminderTaskIds: [] = [] //deprecated. use taskId instead. Remove all references after Sep 1, 2024

	taskId: string = null

	journalEntryId: string = null
	displayDestination = {} //for JournalEntry.displayDestination

	@Type(() => ReminderTriggerItem) //deprecated legacy field
	triggers = []

	isEnabled: boolean = false
	isEditable: boolean = true

	_wasChangedManually: boolean = false

	constructor(type, trigger) {
		super();
		// console.log("ReminderItem: constructor: type = ", type, "typeof type = ", typeof type)
		this.type = type
		// console.log("ReminderItem: constructor: this.type = ", this.type, ", this = ", this)
		this.migrateTriggerSchemaIfNeeded()
		if(trigger){
			this.trigger = trigger
		}
	}

	getStartAt(){
		if(this.triggerAbsoluteTs){
			return this.triggerAbsoluteTs
		}
		return this.trigger.getTriggerTime()
	}

	getDeadlineTime(){
		return this.trigger.getDeadlineTime(this.getStartAt())
	}

	getTemplate(){
		return null
	}
	getTemplateData(){
		return null
	}

	setDisplayDestinationCoachPrivate(){
		this.displayDestination = {[DisplayDestinationEnum.COACH_JOURNAL]: true}
	}
	setDisplayDestinationClientShared(){
		this.displayDestination = {
			[DisplayDestinationEnum.CLIENT_JOURNAL_FOR_COACH]: true,
			[DisplayDestinationEnum.CLIENT_JOURNAL_FOR_CLIENT]: true
		}
	}

	createJournalEntry(){
		let journalEntry = new ReminderJournalEntry(this.title)
		journalEntry.displayDestination = {...this.displayDestination}
		journalEntry.reminderId = this.id
		journalEntry.taskId = this.taskId
		return journalEntry
	}

	dateFormatted(){
		return dayjs(this.getStartAt()).format("MMM DD")
	}

	createQwoachEvent(){
		let qwoachEvent = new ScheduledEvent()
		qwoachEvent.name = this.title
		qwoachEvent.description = this.description
		qwoachEvent.startTime = this.getStartAt()
		qwoachEvent.isAllDay = true
		qwoachEvent.isBusy = false
		return qwoachEvent
	}

	syncFromQwoachEvent(qwoachEvent){
	}

	syncFromTask(task){
		this.taskId = task.id
	}

	onDelete(){
		this.taskId = null
	}


	setUserRecipientId(recipientId){
		this.recipientId = recipientId
		this.recipientType = ProfileTypeEnum.USER
	}

	setClientRecipientId(recipientId){
		this.recipientId = recipientId
		this.recipientType = ProfileTypeEnum.CLIENT
	}

	setTeamMemberRecipientId(recipientId){
		this.recipientId = recipientId
		this.recipientType = ProfileTypeEnum.TEAM_MEMBER
	}

	// getUnscheduledTriggers(){
	// 	let arr = []
	// 	let scheduledCount = this.scheduledReminderTaskIds.length
	//
	// 	for(let i = scheduledCount; i < this.triggers.length; ++i){
	// 		arr.push(this.triggers[i])
	// 	}
	// 	return arr
	// }

	hasScheduledTasks(){
		return this.taskId || this.scheduledReminderTaskIds.length > 0
	}
	resetScheduledIds(){
		this.scheduledReminderTaskIds = []
		this.taskId = null
	}

	migrateTriggerSchemaIfNeeded(){
		if(this.triggers.length){
			this.trigger = this.triggers[0]
			this.triggers = []
		}
	}


}
